/* RESPONSIBLE TEAM: team-ai-insights */
import OptimizeFinReasons from 'embercom/routes/apps/app/automation/fin-ai-agent/analyze/optimize-fin-reasons';

export default class FinStandaloneOptimizeFinReasons extends OptimizeFinReasons {
  analytics = {
    section: 'standalone',
    place: 'optimize-fin-reasons',
  };

  templateName = 'apps/app/automation/fin-ai-agent/analyze/optimize-fin-reasons';
  controllerName = 'apps/app/automation/fin-ai-agent/analyze/optimize-fin-reasons';
  routeWhenNotOptedIn = 'apps.app.standalone.setup';
}
